import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Constants } from 'src/app/constants';
import { PeriodsService } from 'src/app/service/periods.service';

@Component({
  selector: 'app-periods-dropdown',
  templateUrl: './periods-dropdown.component.html',
  styleUrls: ['./periods-dropdown.component.scss'],
  standalone: false
})
export class PeriodsDropdownComponent implements OnInit {
  @Input()
  periodLabel: string = ""
  @Input()
  module: string = ""
  @Output()
  eventHandler = new EventEmitter();
  periodData = []
  selected_period_id
  selected_period_value
  const_plng = 'Planning Period'
  constructor(private readonly ngxUiLoaderService: NgxUiLoaderService, private readonly constants: Constants, private readonly periodsService: PeriodsService) { }

  ngOnInit(): void {
    this.checkPeriodsList()

  }

  checkPeriodsList() {
    if (this.periodLabel == this.const_plng) {  // NOSONAR
      this.getPeriodList();
    } else {
      const tempPeriod = JSON.parse(localStorage.getItem("period_data"))
      if (tempPeriod && tempPeriod.length > 0) {
        this.periodData = tempPeriod
        if (this.periodData.length > 0) {
          this.selected_period_id = this.periodData[0].periodId;
          const tempSelectedPeriodId = localStorage.getItem("selectedPeriodId");
          if (tempSelectedPeriodId) {
            this.selected_period_id = tempSelectedPeriodId
          }

        }
        this.onPeriodChange();
      } else { this.getPeriodList(); }
    }
  }

  getPeriodList() {
    this.periodsService.getPeriodsList().subscribe(
      response => {
        if (response.length > 0) {
          this.periodData = response
          if (this.periodData.length > 0) {
            this.selected_period_id = this.periodData[0].periodId;
          }

          localStorage.setItem("period_data", JSON.stringify(this.periodData))
          if (this.periodLabel == this.const_plng) { // NOSONAR
            const tempSelectedPeriodId = JSON.parse(localStorage.getItem("selectedPeriodId"))
            if (tempSelectedPeriodId && !isNaN(tempSelectedPeriodId)) {
              const tempSelectedPeriodIdIsPresent = this.periodData.findIndex(x => x.periodId == tempSelectedPeriodId)
              this.selected_period_id = this.periodData[tempSelectedPeriodIdIsPresent > 0 ? tempSelectedPeriodIdIsPresent : 0].periodId;
            }
          }

          this.onPeriodChange();

        }
      }, error => {
        console.info(error)
        this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
        this.localEventHandler({ eventType: "NOTIFICATION_ERROR", eventMessage: this.constants.APIErrorMessage });

      }
    );
  }

  onPeriodChange() {
  const selected = this.periodData.find(
    x => x.periodId == Number(this.selected_period_id)  // NOSONAR
  );

  if (!selected) {
    console.error("No matching period found for id:", this.selected_period_id);
    return; // prevent crash
  }

  this.selected_period_value = selected.period;

  if (this.periodLabel == this.const_plng) {  // NOSONAR
    localStorage.setItem("selectedPeriodId", String(this.selected_period_id));
    localStorage.setItem("selectedPeriodValue", this.selected_period_value);
  }

  this.localEventHandler({
    eventType: "CHANGE_PERIOD",
    periodId: Number(this.selected_period_id),
    periodValue: this.selected_period_value,
    module: this.module
  });
}

  localEventHandler(data) {
    this.eventHandler.emit(data);
  }

}
